var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"app-navigation-sidepanel"}},[_c('aside',{staticClass:"z-20 bg-white flex-no-shrink",class:{
            'closed': !_vm.open,
            'drawer-collapsed': !this.$ui.navigationDrawerOpen,
            'drawer-expanded': this.$ui.navigationDrawerOpen,
        },style:({
            height: _vm.$ui.mobile
                ? '100vh'
                : ("calc(100vh - " + (_vm.$ui.toolbarHeight) + "px)"),
        }),attrs:{"id":"app-navigation-sidepanel"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }